<template>
  <!-- Material 3 standard navigation drawer for large windows -->
  <v-navigation-drawer
    aria-label="Main navigation"
    permanent
    color="surface-container"
  >
    <v-list v-if="profile">
      <v-list-item :title="profile.displayName">
        <template v-slot:prepend>
          <v-avatar>
            <v-img
              :src="profile.photoUrl"
              alt=""
              :cover="true"
              v-if="profile.photoUrl"
            />
            <v-icon icon="mdi-account-circle" v-if="!profile.photoUrl" />
          </v-avatar>
        </template>
      </v-list-item>
    </v-list>
    <v-divider />
    <!-- role="none": the links sit directly in the <nav>; a list role would
         require listitem children, which Vuetify's link items are not -->
    <v-list :nav="true" role="none">
      <v-list-item
        rounded="pill"
        min-height="56"
        color="secondary"
        v-for="({ icon, title, value }, index) in items"
        :key="index"
        :prepend-icon="icon"
        :title="title"
        :to="{ name: value }"
        :active="isActive(value)"
      />
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from 'vue';
  import { useRouter } from 'vue-router';
  import type { Profile } from '@/service/profile/types';

  export type MenuItem = {
    icon: string;
    title: string;
    value: string;
  };

  export default defineComponent({
    name: 'NavDrawer',
    props: {
      profile: Object as PropType<Profile>,
      items: Object as PropType<MenuItem[]>,
    },
    setup() {
      const router = useRouter();

      return {
        isActive(name: string): boolean {
          return router.currentRoute.value.matched.some(
            (route) => route.name === name,
          );
        },
      };
    },
  });
</script>
